import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
ReactDOM.render(
	<React.StrictMode>
		<Suspense fallback={'load..'}>
			<App />
		</Suspense>
	</React.StrictMode>,
	document.getElementById('root')
);

reportWebVitals();
